import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Parameters, DEFAULT_PARAMETERS } from '../model/parameters.model';

@Injectable()
export class ParametersService {

    private parameters: BehaviorSubject<Parameters> = new BehaviorSubject<Parameters>(DEFAULT_PARAMETERS);

    constructor(private http: HttpClient) {

    }

    loadParameters(): void {
        if (this.parameters.getValue().countries.length === 0) {
            this.http
                .get('/api/parameters')
                .pipe(
                    map((response: any) => {
                    let rawParameters = response;
                    // Correct parameters name before the back update
                    rawParameters.juridictions.map(typeJuridiction => {
                        typeJuridiction.urgencesRequete = typeJuridiction.typeRequetes.map(typeRequete => {
                            typeRequete.codeUrgence = typeRequete.typeUrgence;
                            return typeRequete;
                        });
                        return typeJuridiction;
                    })
                    return rawParameters;
                }))
                .subscribe(parameters => this.parameters.next(parameters));
        }

        /*if (this.parameters.getValue().countries.length === 0) {
            this.http
                .get('/api/parameters')
                .pipe(
                    map((rawParameters: any) =>
                        rawParameters['juridictions']
                            .map(typeJuridiction => typeJuridiction.urgencesRequete = typeJuridiction.typeRequetes
                                .map(typeRequete => typeRequete.codeUrgence = typeRequete.typeUrgence))
                    )
                )
                .subscribe(parameters => this.parameters.next(parameters));
        }*/
    }

    getParameters(): Observable<Parameters> {
        return this.parameters.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/parameters.service.ts